import type { AxiosInstance } from "axios";
import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from "@tanstack/react-query";

import { useClient } from "@/providers/auth";
import { SearchableEntity } from "@/components/common/Search/types";

import { SearchResponse } from "@/utils/remote/types";

type Params = {
  entity: SearchableEntity;
  searchString: string;
};

export const searchQueryOptions = (
  client: AxiosInstance,
  { entity, searchString }: Params,
) =>
  queryOptions<SearchResponse>({
    queryKey: ["search", { entity: entity.key, searchString }],
    queryFn: ({ signal }) => {
      return client
        .get(`/${entity.apiPath}`, {
          params: { searchString, pageSize: 30 },
          signal,
        })
        .then((response) => response.data);
    },
  });

export const useSearchQuery = ({ entity, searchString }: Params) => {
  const client = useClient();
  return useQuery({
    ...searchQueryOptions(client, { entity, searchString }),
    enabled: Boolean(searchString),
    placeholderData: keepPreviousData,
  });
};
